import React from 'react'

function Imgloader() {
    return (
        <div id='square' className='shimmer'></div>
    )
}

export default Imgloader;
